import { API_BASE_URL } from '../config';

const baseUrl= API_BASE_URL;

export const updateSpace = ( id, data, accessToken,) =>
  fetch(`${baseUrl}places/${id}`, {
    method: "PUT",
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });

export const markLastMinute = ( id, data, accessToken,) =>
  fetch(`${baseUrl}places/${id}/last_minute`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),

  });
